module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/arm-7fe7a886f1798439d81aa7196d377cbf.png";